import React from 'react';
import cN from 'classnames';
import {Draggable} from 'react-beautiful-dnd';

import LocationManagerItem from './LocationManagerItem';


const LocationManagerFavorite = ({location, index, editing, onSetEditable}) => (
    <Draggable draggableId={`${location.id}`} index={index}>
        {({innerRef, draggableProps, dragHandleProps, style}, snapshot) => (
            <LocationManagerItem
                className={cN( {'is-dragging': snapshot.isDragging})}
                style={style}
                ref={innerRef}
                location={location}
                editing={editing}
                onSetEditable={onSetEditable}
                {...draggableProps}
                handle={<strong className="control icon-menu" {...dragHandleProps} />}
            />
        )}
    </Draggable>
);

export default LocationManagerFavorite;
